/**
 * There will be one reducer file per page / common component
 */
import {
    ADD_PROXIES,
    ADD_PROXIES_SUCCESS,
    ADD_PROXIES_FAILURE,
    GET_PROXY_USER_LIST,
    GET_PROXY_USER_LIST_SUCCESS,
    GET_PROXY_LIST,
    GET_PROXY_LIST_SUCCESS,
    UPDATE_PROXY,
    UPDATE_PROXY_FAILURE,
    UPDATE_PROXY_SUCCESS,
    SET_UPDATE_POPUP,
} from 'src/pages/more/pages/proxies/redux/action/actionTypes.js';

const initialState = {
    loading: false,
    proxyUserList: [],
    proxyList: [],
    addProxyStatus: '',
    updateProxyStatus: '',
    updatePopup: false,
    proxyUserListLoading: false,
};

const ProxyReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PROXIES:
            return {
                ...state,
                loading: true,
                addProxyStatus: '',
            };
        case ADD_PROXIES_SUCCESS:
            return {
                ...state,
                loading: false,
                addProxyStatus: action.payload.statusCode,
            };
        case ADD_PROXIES_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case UPDATE_PROXY:
            return {
                ...state,
                loading: true,
                updateProxyStatus: '',
            };
        case UPDATE_PROXY_SUCCESS:
            return {
                ...state,
                loading: false,
                updateProxyStatus: action.payload.statusCode,
            };
        case UPDATE_PROXY_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case GET_PROXY_USER_LIST:
            return {
                ...state,
                proxyUserListLoading: true,
            };
        case GET_PROXY_USER_LIST_SUCCESS:
            return {
                ...state,
                proxyUserList: action.proxyUserList,
                proxyUserListLoading: false,
            };
        case GET_PROXY_LIST:
            return {
                ...state,
            };
        case GET_PROXY_LIST_SUCCESS:
            return {
                ...state,
                proxyList: action.proxyList,
            };

        case SET_UPDATE_POPUP:
            return {
                ...state,
                updatePopup: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default ProxyReducer;
